var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActivityInitialStateButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 6,
    fill: "#D0CCD5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.168 15.6345C19.9028 16.6417 18.65 17.3535 16.1443 18.7771C13.722 20.1532 12.5109 20.8413 11.5349 20.5647C11.1314 20.4503 10.7637 20.2332 10.4672 19.934C9.75 19.2104 9.75 17.807 9.75 15C9.75 12.1931 9.75 10.7896 10.4672 10.066C10.7637 9.76684 11.1314 9.54966 11.5349 9.43532C12.5109 9.15874 13.722 9.8468 16.1443 11.2229C18.65 12.6465 19.9028 13.3583 20.168 14.3655C20.2774 14.7813 20.2774 15.2187 20.168 15.6345Z",
    stroke: "#141B34",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityInitialStateButton);
export default __webpack_public_path__ + "static/media/activity-initial-state-button.c013e732643a0b42569cca70faa7ca9c2312e434ddb3810a82d601beacabf100.svg";
export { ForwardRef as ReactComponent };